import Vue from 'vue';
import axios from 'axios';
import VueI18n from 'vue-i18n';
import lodash from 'lodash';
import * as moment from 'moment/moment';

import dayjs from 'dayjs';
import localeData from "dayjs/plugin/localeData";
import isBetween from "dayjs/plugin/isBetween";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";

window._ = lodash;
window.Vue = Vue;
window.axios = axios;

Vue.use(VueI18n);

function loadLocaleMessages() {
    let locales =require.context(
        "../lang",
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );

    let messages = {};
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

if (!window.locales) {
    window.locales = loadLocaleMessages();
}

// Create VueI18n instance with options
const i18n = new VueI18n({
    locale: window.language, // set locale
    messages: window.locales || {}, // set locale messages
});

window.i18n = i18n;

axios.defaults.headers.common = {
    'X-REQUESTED-WITH': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
};

/* Setup EventHub */
window.EventHub = new Vue();

/* Moment */
moment.locale(window.language);
window.moment = moment;

if (!window.dayjs) {
    window.dayjs = dayjs;
}
window.dayjs.extend(localizedFormat);
window.dayjs.locale(window.locale);


window.dayjs.extend(localeData);
window.dayjs.extend(isBetween);
window.dayjs.extend(utc);

require("dayjs/locale/ro");
require("dayjs/locale/es");
require("dayjs/locale/pt");
require("dayjs/locale/el");
require("dayjs/locale/fr");
require("dayjs/locale/de");
require("dayjs/locale/it");


/* Smoothscroll */
// require('smoothscroll-polyfill').polyfill();
// window.__forceSmoothScrollPolyfill__ = true;


$.fn.serializeObject = function()
{
    var o = {};
    var a = this.serializeArray();
    $.each(a, function() {
        if (o[this.name]) {
            if (!o[this.name].push) {
                o[this.name] = [o[this.name]];
            }
            o[this.name].push(this.value || '');
        } else {
            o[this.name] = this.value || '';
        }
    });
    return o;
};
